import React, { Component } from "react";
import PropTypes from "prop-types";
import { Form, Field, withFormik } from "formik";
import isEmpty from "lodash/isEmpty";

import i18n from "../../../../translations/i18n";
import { USER_AUTH_SHAPE } from "../../../../constants/userConstants";
import { PASSWORD_MIN_LENGTH } from "../../../../config";

import FormGroup from "../../../../components/ui/form/group";
import FormActions from "../../../../components/ui/form/actions";
import FormError from "../../../../components/ui/form/error";
import InputField from "../../../../components/ui/form/input_field";
import Button from "../../../../components/ui/form/button";


class ChangePasswordForm extends Component {

  constructor(props) {
    super(props);
  }

  componentDidUpdate(prevProps, prevState) {
    const { auth, setSubmitting } = this.props;

    if (prevProps.auth !== auth && auth.error) {
      setSubmitting(false);
    }
  }

  render() {
    const {
      auth,
      location,
      touched,
      isSubmitting,
      handleSubmit,
    } = this.props;

    return(
      <Form>
        <div className="modal__form-fields-group">
          <FormGroup label={i18n.t("pages.change_password.form.password.label")} touched={touched.password}>
            <Field
              component={InputField}
              name="password"
              type="password"
              required
            />
          </FormGroup>
        </div>

        <FormActions className="modal__form-button-wrapper">
          <FormError>
            {auth.error}
          </FormError>
          <Button
            className="modal__form-button"
            type="submit"
            disabled={isSubmitting}
            onSubmit={handleSubmit}
          >
            {i18n.t("pages.change_password.form.submit.title")}
          </Button>
        </FormActions>
      </Form>
    )
  }
}

const ChangePasswordFormWithFormik = withFormik({
  enableReinitialize: true,
  mapPropsToValues: ({initialValues}) => initialValues,
  handleSubmit: (values, {props: {onSubmit}}) => onSubmit(values),
  validate: (values) => {
    let errors = {};

    if (isEmpty(values.password)) {
      errors.password = i18n.t("validation.field.required");
    } else if (values.password.length < PASSWORD_MIN_LENGTH) {
      errors.password = i18n.t("validation.password.toShort", {length: PASSWORD_MIN_LENGTH});
    }

    return errors;
  },
})(ChangePasswordForm);

ChangePasswordFormWithFormik.propTypes = {
  auth: PropTypes.shape(USER_AUTH_SHAPE).isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default ChangePasswordFormWithFormik
